import augmentEditUserModal from '../common/augmentEditUserModal';
import registerModels from '../common/registerModels';

app.initializers.add('glowingblue-auto-moderator', () => {
	registerModels();
	augmentEditUserModal();
});
